import "./GetDataError.css";

const GetDataError = () => {
  return (
    <div className="get-data-error-box">
      <p>😱 데이터를 불러오지 못 했습니다.</p>
    </div>
  );
};

export default GetDataError;
